export const name = 'siteLocaleService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-locale' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
